(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["freewink-product-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const svgNs = 'http://www.w3.org/2000/svg';

    const safeUrl = (value) => {
      try {
        const url = new URL(String(value), window.location.origin);
        return ['http:', 'https:'].includes(url.protocol) ? url.href : '';
      } catch {
        return '';
      }
    };

    const flag = (code) => {
      const normalized = String(code || '').toUpperCase();
      if (!/^[A-Z]{2}$/.test(normalized)) return '🌐';
      return String.fromCodePoint(...[...normalized].map((letter) => 127397 + letter.charCodeAt(0)));
    };

    const star = (fill, id) => {
      const svg = document.createElementNS(svgNs, 'svg');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('class', 'freewink-reviews__star');
      svg.setAttribute('aria-hidden', 'true');
      const defs = document.createElementNS(svgNs, 'defs');
      const gradient = document.createElementNS(svgNs, 'linearGradient');
      gradient.id = id;
      const on = document.createElementNS(svgNs, 'stop');
      on.setAttribute('offset', `${Math.max(0, Math.min(1, fill)) * 100}%`);
      on.setAttribute('stop-color', 'var(--fw-review-accent)');
      const off = document.createElementNS(svgNs, 'stop');
      off.setAttribute('offset', `${Math.max(0, Math.min(1, fill)) * 100}%`);
      off.setAttribute('stop-color', '#d9d9d9');
      gradient.append(on, off);
      defs.append(gradient);
      const path = document.createElementNS(svgNs, 'path');
      path.setAttribute('d', 'M12 2.5l2.85 5.78 6.38.93-4.62 4.5 1.09 6.35L12 17.06l-5.7 3 1.09-6.35-4.62-4.5 6.38-.93L12 2.5z');
      path.setAttribute('fill', `url(#${id})`);
      svg.append(defs, path);
      return svg;
    };

    class FreewinkReviews {
      constructor(root) {
        if (root.dataset.initialized === 'true') return;
        root.dataset.initialized = 'true';
        this.root = root;
        this.filter = 'all';
        this.sort = 'recent';
        this.visible = Number(root.dataset.pageSize) || 6;
        this.lightboxItems = [];
        this.lightboxIndex = 0;
        this.labels = {
          customer: root.dataset.labelCustomer,
          verified: root.dataset.labelVerified,
          readMore: root.dataset.labelReadMore,
          showLess: root.dataset.labelShowLess,
          officialReply: root.dataset.labelOfficialReply,
          reviewSingular: root.dataset.labelReviewSingular,
          reviewPlural: root.dataset.labelReviewPlural,
          starSingular: root.dataset.labelStarSingular,
          starPlural: root.dataset.labelStarPlural,
          openImage: root.dataset.labelOpenImage,
          customerPhoto: root.dataset.labelCustomerPhoto,
          customerImage: root.dataset.labelCustomerImage,
          customerVideo: root.dataset.labelCustomerVideo,
          amazonSource: root.dataset.labelAmazonSource,
          ratingMissing: root.dataset.labelRatingMissing,
          filesInvalid: root.dataset.labelFilesInvalid,
          submissionUnavailable: root.dataset.labelSubmissionUnavailable,
          submitting: root.dataset.labelSubmitting,
          submitFailed: root.dataset.labelSubmitFailed,
          submitSuccess: root.dataset.labelSubmitSuccess,
        };
        this.data = this.readData();
        this.reviews = Array.isArray(this.data.reviews) ? this.data.reviews : [];
        this.bind();
        this.render();
      }

      readData() {
        const parseNode = (selector, fallback) => {
          const node = this.root.querySelector(selector);
          try {
            return JSON.parse(node?.textContent || '') || fallback;
          } catch {
            return fallback;
          }
        };
        const stored = parseNode('[data-review-payload]', {});
        const manual = parseNode('[data-review-manual-payload]', []);
        const batch = this.readBatchData(parseNode('[data-review-batch-payload]', ''));
        const storedReviews = Array.isArray(stored.reviews) ? stored.reviews : [];
        return { ...stored, reviews: [...storedReviews, ...(Array.isArray(manual) ? manual : []), ...batch] };
      }

      readBatchData(rawValue) {
        if (typeof rawValue !== 'string' || !rawValue.trim()) return [];
        try {
          return rawValue
            .split(/\r?\n/)
            .map((line, index) => {
              const fields = line.split('|').map((value) => value.trim());
              if (fields.length < 6) return null;
              const [rating, author, country, date, title, ...tail] = fields;
              let verifiedPurchase = false;
              const possibleVerified = String(tail.at(-1) || '').toLowerCase();
              if (['true', 'verified', 'yes', '1'].includes(possibleVerified)) {
                verifiedPurchase = true;
                tail.pop();
              } else if (['false', 'unverified', 'no', '0'].includes(possibleVerified)) {
                tail.pop();
              }
              let source = 'store';
              const possibleSource = String(tail.at(-1) || '').toLowerCase();
              if (['amazon', 'store', 'other'].includes(possibleSource)) source = String(tail.pop()).toLowerCase();
              const content = tail.join('|').trim();
              if (!content) return null;
              return {
                id: `batch-${this.root.dataset.sectionId}-${index}`,
                author,
                country: country || 'US',
                rating: Math.max(1, Math.min(5, Number(rating) || 5)),
                date,
                verified_purchase: verifiedPurchase,
                source,
                variant_title: '',
                title,
                content,
                images: [],
                videos: [],
                store_reply: '',
              };
            })
            .filter(Boolean);
        } catch {
          return [];
        }
      }

      bind() {
        this.root.querySelectorAll('[data-review-filter]').forEach((button) => {
          button.addEventListener('click', () => {
            this.filter = button.dataset.reviewFilter || 'all';
            this.visible = Number(this.root.dataset.pageSize) || 6;
            this.root.querySelectorAll('[data-review-filter]').forEach((item) => item.classList.toggle('is-active', item === button));
            this.renderList();
          });
        });
        this.root.querySelector('[data-review-sort]')?.addEventListener('change', (event) => {
          this.sort = event.target.value;
          this.renderList();
        });
        this.root.querySelector('[data-review-more]')?.addEventListener('click', () => {
          this.visible += Number(this.root.dataset.pageSize) || 6;
          this.renderList();
        });

        const dialog = this.root.querySelector('[data-review-dialog]');
        this.root.querySelector('[data-review-open]')?.addEventListener('click', () => {
          const started = this.root.querySelector('[data-review-started]');
          if (started) started.value = String(Date.now());
          dialog?.showModal();
        });
        this.root.querySelector('[data-review-close]')?.addEventListener('click', () => dialog?.close());
        dialog?.addEventListener('click', (event) => {
          if (event.target === dialog) dialog.close();
        });

        const ratingInput = this.root.querySelector('[data-review-rating-input]');
        const ratingButtons = [...this.root.querySelectorAll('[data-rating]')];
        ratingButtons.forEach((button) => {
          const paint = (value) => ratingButtons.forEach((item) => item.classList.toggle('is-active', Number(item.dataset.rating) <= value));
          button.addEventListener('mouseenter', () => paint(Number(button.dataset.rating)));
          button.addEventListener('focus', () => paint(Number(button.dataset.rating)));
          button.addEventListener('click', () => {
            ratingInput.value = button.dataset.rating;
            ratingInput.dispatchEvent(new Event('change'));
            paint(Number(button.dataset.rating));
          });
        });
        this.root.querySelector('[data-review-rating-picker]')?.addEventListener('mouseleave', () => paintRating(ratingButtons, Number(ratingInput?.value || 0)));

        this.root.querySelector('[data-review-form]')?.addEventListener('submit', (event) => this.submit(event));
        const lightbox = this.root.querySelector('[data-review-lightbox]');
        this.root.querySelector('[data-lightbox-close]')?.addEventListener('click', () => lightbox?.close());
        this.root.querySelector('[data-lightbox-prev]')?.addEventListener('click', () => this.moveLightbox(-1));
        this.root.querySelector('[data-lightbox-next]')?.addEventListener('click', () => this.moveLightbox(1));
        lightbox?.addEventListener('click', (event) => {
          if (event.target === lightbox) lightbox.close();
        });
      }

      summary() {
        const computed = { total_reviews: this.reviews.length, average_rating: 0, rating_breakdown: { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 } };
        this.reviews.forEach((review) => {
          const rating = Math.max(1, Math.min(5, Number(review.rating) || 0));
          computed.rating_breakdown[rating] += 1;
          computed.average_rating += rating;
        });
        if (computed.total_reviews) computed.average_rating /= computed.total_reviews;
        return computed;
      }

      render() {
        const summary = this.summary();
        const total = Number(summary.total_reviews) || this.reviews.length;
        const average = Number(summary.average_rating) || 0;
        this.root.dataset.reviewTotal = String(total);
        this.root.dataset.reviewAverage = average.toFixed(2);
        const averageNode = this.root.querySelector('[data-review-average]');
        if (averageNode) averageNode.textContent = average.toFixed(1);
        const totalNode = this.root.querySelector('[data-review-total]');
        if (totalNode) totalNode.textContent = `${total} ${total === 1 ? this.labels.reviewSingular : this.labels.reviewPlural}`;
        this.renderStars(this.root.querySelector('[data-review-summary-stars]'), average, `summary-${this.root.dataset.sectionId}`);
        this.renderBreakdown(summary.rating_breakdown || {}, total);
        const toolbar = this.root.querySelector('[data-review-toolbar]');
        if (toolbar) toolbar.hidden = !this.reviews.length;
        this.renderList();
        document.dispatchEvent(
          new CustomEvent('freewink:reviews:summary', {
            detail: {
              productId: this.root.dataset.productId,
              total,
              average,
              targetId: this.root.id,
            },
          }),
        );
      }

      renderStars(container, rating, idPrefix) {
        if (!container) return;
        container.replaceChildren();
        for (let index = 1; index <= 5; index += 1) {
          container.append(star(Math.max(0, Math.min(1, rating - index + 1)), `${idPrefix}-${index}`));
        }
      }

      renderBreakdown(breakdown, total) {
        const container = this.root.querySelector('[data-review-breakdown]');
        if (!container) return;
        container.replaceChildren();
        for (let rating = 5; rating >= 1; rating -= 1) {
          const count = Number(breakdown[rating] ?? breakdown[String(rating)]) || 0;
          const percent = total ? Math.round((count / total) * 100) : 0;
          const row = document.createElement('div');
          row.className = 'freewink-reviews__breakdown-row';
          const label = document.createElement('span');
          label.textContent = `${rating} ${rating === 1 ? this.labels.starSingular : this.labels.starPlural}`;
          const bar = document.createElement('span');
          bar.className = 'freewink-reviews__bar';
          const fill = document.createElement('span');
          fill.style.setProperty('--fw-review-percent', `${percent}%`);
          bar.append(fill);
          const value = document.createElement('span');
          value.textContent = String(count);
          row.append(label, bar, value);
          container.append(row);
        }
      }

      currentReviews() {
        const filtered = this.reviews.filter((review) => {
          if (this.filter === 'all') return true;
          if (this.filter === 'media') {
            const hasImages = Array.isArray(review.images) && review.images.length > 0;
            const hasVideos = Array.isArray(review.videos) && review.videos.length > 0;
            return hasImages || hasVideos;
          }
          return Number(review.rating) === Number(this.filter);
        });
        return filtered.sort((left, right) => {
          if (this.sort === 'highest') return Number(right.rating) - Number(left.rating);
          if (this.sort === 'lowest') return Number(left.rating) - Number(right.rating);
          return new Date(right.date || 0).getTime() - new Date(left.date || 0).getTime();
        });
      }

      renderList() {
        const list = this.root.querySelector('[data-review-list]');
        const empty = this.root.querySelector('[data-review-empty]');
        const more = this.root.querySelector('[data-review-more]');
        if (!list || !empty || !more) return;
        const items = this.currentReviews();
        list.replaceChildren(...items.slice(0, this.visible).map((review, index) => this.card(review, index)));
        empty.hidden = items.length > 0;
        more.hidden = items.length <= this.visible;
      }

      card(review, index) {
        const article = document.createElement('article');
        article.className = 'freewink-review-card';
        if (review.block_id) {
          const marker = [...this.root.querySelectorAll('[data-review-block-marker]')].find((item) => item.dataset.reviewBlockMarker === String(review.block_id));
          marker?.getAttributeNames().filter((name) => name.startsWith('data-shopify-editor')).forEach((name) => article.setAttribute(name, marker.getAttribute(name)));
        }
        const meta = document.createElement('div');
        meta.className = 'freewink-review-card__meta';
        const author = document.createElement('div');
        author.className = 'freewink-review-card__author';
        const name = document.createElement('strong');
        name.textContent = `${flag(review.country)} ${review.author || this.labels.customer}`;
        author.append(name);
        if (String(review.source || '').toLowerCase() === 'amazon') {
          const source = document.createElement('span');
          source.className = 'freewink-review-card__source';
          source.textContent = review.source_verified || review.verified_purchase ? `${this.labels.amazonSource} · ${this.labels.verified}` : this.labels.amazonSource;
          author.append(source);
        } else if (review.verified_purchase) {
          const verified = document.createElement('span');
          verified.className = 'freewink-review-card__verified';
          verified.textContent = `✓ ${this.labels.verified}`;
          author.append(verified);
        }
        const date = document.createElement('time');
        date.className = 'freewink-review-card__date';
        date.dateTime = String(review.date || '');
        date.textContent = formatDate(review.date);
        meta.append(author, date);

        const rating = document.createElement('div');
        rating.className = 'freewink-review-card__rating';
        this.renderStars(rating, Number(review.rating) || 0, `card-${this.root.dataset.sectionId}-${review.id || index}`);
        const title = document.createElement('h3');
        title.textContent = review.title || '';
        const content = document.createElement('p');
        content.className = 'freewink-review-card__content';
        const fullText = String(review.content || '');
        const truncated = fullText.length > 420;
        content.textContent = truncated ? `${fullText.slice(0, 420).trim()}…` : fullText;

        article.append(meta, rating, title);
        if (review.variant_title) {
          const variant = document.createElement('p');
          variant.className = 'freewink-review-card__variant';
          variant.textContent = String(review.variant_title);
          article.append(variant);
        }
        article.append(content);
        if (truncated) {
          const toggle = document.createElement('button');
          toggle.type = 'button';
          toggle.className = 'freewink-review-card__toggle';
          toggle.textContent = this.labels.readMore;
          toggle.addEventListener('click', () => {
            const expanded = toggle.dataset.expanded === 'true';
            toggle.dataset.expanded = String(!expanded);
            toggle.textContent = expanded ? this.labels.readMore : this.labels.showLess;
            content.textContent = expanded ? `${fullText.slice(0, 420).trim()}…` : fullText;
          });
          article.append(toggle);
        }

        const images = Array.isArray(review.images) ? review.images.map(safeUrl).filter(Boolean) : [];
        const videos = Array.isArray(review.videos)
          ? review.videos
              .map((item) => {
                if (typeof item === 'string') return { url: safeUrl(item), poster: '' };
                return { url: safeUrl(item?.url), poster: safeUrl(item?.poster) };
              })
              .filter((item) => item.url)
          : [];
        if (images.length || videos.length) {
          const media = document.createElement('div');
          media.className = 'freewink-review-card__media';
          images.forEach((url, mediaIndex) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.setAttribute('aria-label', `${this.labels.openImage} ${mediaIndex + 1}`);
            const image = document.createElement('img');
            image.src = url;
            image.alt = review.title ? `${review.title} ${this.labels.customerPhoto}` : this.labels.customerPhoto;
            image.loading = 'lazy';
            image.width = 192;
            image.height = 192;
            button.append(image);
            button.addEventListener('click', () => this.openLightbox(images, mediaIndex, image.alt));
            media.append(button);
          });
          videos.forEach((item) => {
            const video = document.createElement('video');
            video.controls = true;
            video.preload = 'metadata';
            video.playsInline = true;
            video.src = item.url;
            video.setAttribute('aria-label', this.labels.customerVideo);
            if (item.poster) video.poster = item.poster;
            media.append(video);
          });
          article.append(media);
        }

        if (review.store_reply) {
          const reply = document.createElement('div');
          reply.className = 'freewink-review-card__reply';
          const label = document.createElement('strong');
          label.textContent = this.labels.officialReply;
          const text = document.createElement('span');
          text.textContent = String(review.store_reply);
          reply.append(label, text);
          article.append(reply);
        }
        return article;
      }

      openLightbox(items, index, alt) {
        const dialog = this.root.querySelector('[data-review-lightbox]');
        this.lightboxItems = items;
        this.lightboxIndex = index;
        this.lightboxAlt = alt;
        this.updateLightbox();
        dialog?.showModal();
      }

      moveLightbox(direction) {
        if (!this.lightboxItems.length) return;
        this.lightboxIndex = (this.lightboxIndex + direction + this.lightboxItems.length) % this.lightboxItems.length;
        this.updateLightbox();
      }

      updateLightbox() {
        const image = this.root.querySelector('[data-lightbox-image]');
        if (!image) return;
        image.src = this.lightboxItems[this.lightboxIndex] || '';
        image.alt = this.lightboxAlt || this.labels.customerImage;
      }

      async submit(event) {
        event.preventDefault();
        const form = event.currentTarget;
        const status = this.root.querySelector('[data-review-status]');
        const submit = this.root.querySelector('[data-review-submit]');
        const endpoint = this.root.dataset.endpoint;
        const rating = form.elements.rating?.value;
        if (!rating) {
          this.setStatus(status, this.labels.ratingMissing, true);
          return;
        }
        const files = [...(form.elements.images?.files || [])];
        if (files.length > 5 || files.some((file) => file.size > 5 * 1024 * 1024)) {
          this.setStatus(status, this.labels.filesInvalid, true);
          return;
        }
        if (!endpoint) {
          this.setStatus(status, this.labels.submissionUnavailable, true);
          return;
        }
        submit.disabled = true;
        this.setStatus(status, this.labels.submitting, false);
        try {
          const response = await fetch(endpoint, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
          const result = await response.json().catch(() => ({}));
          if (!response.ok) throw new Error(result.message || this.labels.submitFailed);
          form.reset();
          paintRating([...this.root.querySelectorAll('[data-rating]')], 0);
          this.setStatus(status, result.message || this.labels.submitSuccess, false, true);
        } catch (error) {
          this.setStatus(status, error.message || this.labels.submitFailed, true);
        } finally {
          submit.disabled = false;
        }
      }

      setStatus(node, message, error, success = false) {
        if (!node) return;
        node.textContent = message;
        node.classList.toggle('is-error', Boolean(error));
        node.classList.toggle('is-success', Boolean(success));
      }
    }

    const paintRating = (buttons, value) => buttons.forEach((item) => item.classList.toggle('is-active', Number(item.dataset.rating) <= value));
    const formatDate = (value) => {
      const date = new Date(value || 0);
      return Number.isNaN(date.getTime()) ? '' : new Intl.DateTimeFormat(document.documentElement.lang || 'en-US', { year: 'numeric', month: 'short', day: 'numeric' }).format(date);
    };
    const init = (scope = document) => scope.querySelectorAll('[data-freewink-reviews]').forEach((root) => new FreewinkReviews(root));
    init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
